/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCurrencyCommand } from '../models/CreateCurrencyCommand';
import type { ResponseData_Int32 } from '../models/ResponseData_Int32';
import type { ResponseData_PagedResponse_GetCurrencyResponse } from '../models/ResponseData_PagedResponse_GetCurrencyResponse';
import type { SetCurrencyActiveCommand } from '../models/SetCurrencyActiveCommand';
import type { UpdateCurrencyCommand } from '../models/UpdateCurrencyCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CurrencyService {
    /**
     * Получить список валют
     * @returns ResponseData_PagedResponse_GetCurrencyResponse OK
     * @throws ApiError
     */
    public static getApiV1Currency({
        search,
        pageNumber,
        pageSize,
    }: {
        search?: string,
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_PagedResponse_GetCurrencyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/currency',
            query: {
                'search': search,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Добавить валюту
     * @returns ResponseData_Int32 OK
     * @throws ApiError
     */
    public static postApiV1CurrencyCreate({
        requestBody,
    }: {
        requestBody?: CreateCurrencyCommand,
    }): CancelablePromise<ResponseData_Int32> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/currency/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Изменить валюту
     * @returns any OK
     * @throws ApiError
     */
    public static putApiV1CurrencyUpdate({
        requestBody,
    }: {
        requestBody?: UpdateCurrencyCommand,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/currency/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Изменить статус
     * @returns any OK
     * @throws ApiError
     */
    public static putApiV1CurrencySetStatus({
        requestBody,
    }: {
        requestBody?: SetCurrencyActiveCommand,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/currency/setStatus',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
